import React from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import MtechSelfSponsoredEle from './MtechSelfSponsoredEle'


function Main() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Admission"/>
            <MtechSelfSponsoredEle />
        </>
    )
}

export default Main